var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Support(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-support",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M10,20A9.988,9.988,0,0,1,2.938,2.938,9.988,9.988,0,1,1,17.062,17.062,9.928,9.928,0,0,1,10,20ZM7.5,14.3,6,16.9a7.676,7.676,0,0,0,8,0l-1.5-2.6a4.968,4.968,0,0,1-5,0ZM10,7a2.945,2.945,0,1,0,2.137.862A2.993,2.993,0,0,0,10,7Zm4-3.9h0L12.5,5.7A5.009,5.009,0,0,1,15,10h3a7.794,7.794,0,0,0-4-6.9Zm-8,0A7.8,7.8,0,0,0,2,10H5A5.01,5.01,0,0,1,7.5,5.7L6,3.1Z",
    transform: "translate(2 2)",
    fill: "#02466a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Support);
export default __webpack_public_path__ + "static/media/icon-24-support.8fc7bc6982d3ac05dee133da1d28f8f1.svg";
export { ForwardRef as ReactComponent };